import { useEffect } from "react";

export const useInterval = (callback: any, delay?: number, condition?: any) => {
    useEffect(() => {
      const intervalCallback = () => callback();
  
      if (delay !== null) {
        let id = setInterval(intervalCallback, delay);
        return () => clearInterval(id);
      }
    }, [delay, callback, condition]);
  };
  